import parse from 'html-react-parser'
import { sectionColour } from 'utils/sectionColour'

type Props = {
  moreInfoTitle?: string
  moreInfoDescription?: string
  moreInfoCallToActionText?: string
  moreInfoCallToActionUrl?: string
}

const PreviewContentPanel = ({
  moreInfoTitle,
  moreInfoDescription,
  moreInfoCallToActionText,
  moreInfoCallToActionUrl,
}: Props) => {
  const { backgroundColor, textColor, headingColor, buttonColor } =
    sectionColour('branding')

  const hasCta = Boolean(
    (moreInfoCallToActionText && moreInfoCallToActionText.trim() !== '') ||
      (moreInfoCallToActionUrl && moreInfoCallToActionUrl.trim() !== ''),
  )

  return (
    <section className={`${backgroundColor} px-9 py-8 lg:py-12 lg:px-12`}>
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        <div>
          <div className="text-center lg:text-left">
            <h2 className={`mb-2 ${headingColor}`}>
              {moreInfoTitle || 'Sample More Info Title'}
            </h2>
            <hr className="hr rounded-cap bg-branding-secondary" />
          </div>
          <p className={`text-center sm:text-left font-medium ${textColor}`}>
            {moreInfoDescription
              ? parse(moreInfoDescription)
              : 'This is a sample description for your More Info content panel. Add rich text to see how it will render.'}
          </p>
        </div>
        {hasCta && (
          <div className="pt-2 sm:pt-5 flex justify-center lg:justify-end items-end h-full w-full">
            <a
              href={moreInfoCallToActionUrl || '#'}
              className={`${buttonColor} inline-flex button button-radius-large button-large`}
              onClick={e => e.preventDefault()}
            >
              {moreInfoCallToActionText || 'Learn more'}
            </a>
          </div>
        )}
      </div>
    </section>
  )
}

export default PreviewContentPanel
